module.exports = __webpack_public_path__ + "static/img/solve4.614db126.png";